export const players = {
  players: "Players",
  createNewPlayer: "Create New Player",
  createPlayer: "Create Player",
  playerList: "Players List",
  search: "Search",
  advanceFilter: "Advance Filter",
  mobileNumber: "MOBILE NUMBER",
  bankAccount: "Bank Account",
  bankNumber: "Bank Number",
  ipAddress: "IP ADDRESS",
  lastLoginIpAddress: "LAST LOGIN IP ADDRESS",
  activeStatus: "ACTIVE STATUS",
  date: "Date",
  currentBalance: "CURRENT BALANCE",
  action: "Action",
  neverLogin: "Never Login",
  dateOfApplication: "Date Of Application",
  bankAccountNumber: "Bank Account Number",
  bankAccountName: "Bank Account Name",
  cancel: "Cancel",
  filter: "Filter",
  username: "Username",
  password: "Password",
  phoneNumber: "Phone Number",
  selectBank: "Select Bank",
  affiliateUsername: "Affiliate Username",
  id: "Id",
  firstname: "First Name",
  confirm: "confirm",
  cancel: "cancel",
  confirmActivation: "Confirm Activation",
  confirmUserSespension: "Confirm user Suspension",
};
